module.exports = __webpack_public_path__ + "assets/img/404@2x.a42eba2e.png";